import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
} from 'reactstrap';

import ImporterModalBrowserBreadcrumbs from './ModalBrowserBreadcrumbs';
import ImporterModalBrowserSelected from './ModalBrowserSelected';
import ImporterModalBrowserList from './ModalBrowserList';

const ImporterModalBrowser = ({
  importer,
  selectedItems,
  setSelectedItems,
}) => {
  const [path, setPath] = useState('/');
  const [pathElements, setPathElements] = useState([]);

  const selectedFolders = selectedItems.filter(si => (si.type === 'folder')).length;
  const selectedFiles = selectedItems.filter(si => (si.type === 'file')).length;

  useEffect(() => {
    const newPathElements = [];
    if (path !== '/') {
      let found = false;
      pathElements.forEach((pe) => {
        if (!found) {
          newPathElements.push(pe);
        }
        if (pe.path === path) {
          found = true;
        }
      });
    }
    setPathElements(newPathElements);
  }, [path]); // eslint-disable-line react-hooks/exhaustive-deps

  const addPathElement = (element) => {
    pathElements.push(element);
    setPathElements(pathElements);
  };

  return (
    <div className="modal-import-browser">
      <Row className="modal-import-browser-header">
        <Col xs="12">
          <ImporterModalBrowserBreadcrumbs
            importer={importer}
            path={path}
            pathElements={pathElements}
            setPath={setPath}
          />
        </Col>
        <Col>
          <ImporterModalBrowserSelected
            selectedFolders={selectedFolders}
            selectedFiles={selectedFiles}
          />
        </Col>
      </Row>
      <Row className="modal-import-browser-list">
        <Col>
          <ImporterModalBrowserList
            importer={importer}
            path={path}
            pathElements={pathElements}
            addPathElement={addPathElement}
            setPath={setPath}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
        </Col>
      </Row>
    </div>
  );
};

ImporterModalBrowser.propTypes = {
  importer: PropTypes.object.isRequired,
  selectedItems: PropTypes.array.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
};

export default ImporterModalBrowser;
